import repository from '@/utils/repository';

const resource = '/move/MNG_Master007';

export default {
    searchStationInfo: (data) => {
        return repository.post(`${resource}/searchItem`, {
            ...data
        });
    }
};
